import React, {Component} from "react";
import UserSearch from "../../input/UserSearch.component";
import * as reduxSelectors from "../../store/application.reducers";
import {connect} from "react-redux";
import {getCostUnitsBranches} from "../costunits.action";
import okGreen from "../../../assets/okVectorGreen.svg";
import okGray from "../../../assets/okVectorGray.svg";
import { Button, ButtonType } from "components/common/Button.component";
import { DropdownSelect } from "components/common/dropdown/DropdownSelect.component";
import { DropdownSelectTypes, DropdownPosition } from "types/gaiaComponents/dropdownButton.types";

class CostUnitsApproversNewRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            costUnit: this.props.costUnit
        };

        this.saveRow = this.saveRow.bind(this);
        this.changeUser = this.changeUser.bind(this);
        this.changeRole = this.changeRole.bind(this);
        this.changeDeputy = this.changeDeputy.bind(this);
        this.changeSkip = this.changeSkip.bind(this);
    }

    saveRow() {
        this.props.saveNewRow(this.state.costUnit);
    }

    changeUser(user) {
        let newCostUnit = Object.assign({}, this.state.costUnit);
        newCostUnit.idUser = user.value;
        newCostUnit.userNameAndEmail = user.label;
        if(newCostUnit.skip && newCostUnit.idUser) {
            newCostUnit.skip = false;
        }
        this.setState({
            costUnit: newCostUnit
        });
    }

    changeRole(value) {
        let newCostUnit = Object.assign({}, this.state.costUnit);
        newCostUnit.role = value.roleId;
        newCostUnit.roleName = value.name;
        this.setState({
            costUnit: newCostUnit
        });
    }

    changeBranch(value) {
        let newCostUnit = Object.assign({}, this.state.costUnit);
        newCostUnit.branchId = value.branchId;
        newCostUnit.branchName = value.name;
        this.setState({
            costUnit: newCostUnit
        });
    }

    changeDeputy(event) {
        let newCostUnit = Object.assign({}, this.state.costUnit);
        newCostUnit.deputy = event.target.checked;

        this.setState({
            costUnit: newCostUnit
        });
    }

    changeSkip(skip) {
        let newCostUnit = Object.assign({}, this.state.costUnit);
        newCostUnit.skip = skip;
        if (skip) {
            newCostUnit.idUser = null;
            newCostUnit.userNameAndEmail = null;
        }

        this.setState({
            costUnit: newCostUnit
        });
    }

    render() {
        let isSaveEnabled = (this.state.costUnit.role && this.state.costUnit.idUser) || this.state.costUnit.skip;
        return (<div className="row assign-approvers-row-edit gutters-8">

            <div className={`${this.props.costUnitsBranches.length > 0 ? "col-md-2" : "col-md-3"}`}>
                    <DropdownSelect
                        id="cost_role"
                        type={DropdownSelectTypes.VALUE}
                        value={this.state.costUnit.roleName}
                        position={DropdownPosition.BOTTOM_RIGHT}
                        extraClasses="w-100"
                        items={this.props.costUnitTypes.map((costUnit) => {
                            return {
                                key: costUnit.name + "-" + costUnit.dimension,
                                text: costUnit.name,
                                onClick: () => this.changeRole(costUnit)
                            };
                        })}
                    />
            </div>
            <div className={`${this.props.costUnitsBranches.length > 0 ? "col-md-3" : "col-md-5"}`}>
                <UserSearch className="col-md-5" ref="recipientInput" propagateValue={this.changeUser}
                            value={{
                                label: this.state.costUnit.userNameAndEmail,
                                value: this.state.costUnit.idUser
                            }}
                            placeholder={this.props.translate("settings.substitute.selectUser")}
                            includeSameUser={true}
                            menuPosition={"fixed"}
                            menuPortalTarget={document.body}
                            translate={this.props.translate}/>
            </div>
            {this.props.costUnitsBranches.length > 0 &&
                <div className="col-md-3">
                    <DropdownSelect
                        id="cost_branch"
                        type={DropdownSelectTypes.VALUE}
                        value={this.state.costUnit.branchName || this.props.translate("costUnitAssignApprovers.anyBranch")}
                        position={DropdownPosition.BOTTOM_RIGHT}
                        extraClasses="w-100"
                        items={[{
                            key: '0',
                            text: this.props.translate("costUnitAssignApprovers.anyBranch"),
                            onClick: () => this.changeBranch({ branchId: 0, name: this.props.translate("costUnitAssignApprovers.anyBranch") })
                        }, ...this.props.costUnitsBranches.filter((branch) => {
                            return branch.active && !branch.deleted
                        }).map((branch) => {
                            return {
                                key: branch.name + "-" + branch.branchId,
                                text: branch.name,
                                onClick: () => this.changeBranch(branch)
                            };
                        })]}
                    />
                </div>
            }
            <div className="col-md-1">
                <div className="column-content">
                    {this.state.costUnit.deputy ?
                        <img src={okGreen} alt={"checked"} onClick={this.changeDeputy} /> :
                        <img src={okGray} alt={"not checked"} onClick={this.changeDeputy} />
                    }
                </div>
            </div>

            <div className="col-md-1">
                <DropdownSelect
                    id="skipCostUnit"
                    type={DropdownSelectTypes.VALUE}
                    value={this.state.costUnit.skip ? this.props.translate("costUnitAssignApprovers.yes") : this.props.translate("costUnitAssignApprovers.no")}
                    position={DropdownPosition.BOTTOM_RIGHT}
                    extraClasses="w-100"
                    items={[{
                        key: '0',
                        text: this.props.translate("costUnitAssignApprovers.yes"),
                        onClick: () => this.changeSkip(true),
                        dataCy: "__tst_CU_skipCostUnit_dropDownButton_yes"
                    }, {
                        key: '1',
                        text: this.props.translate("costUnitAssignApprovers.no"),
                        onClick: () => this.changeSkip(false),
                        dataCy: "__tst_CU_skipCostUnit_dropDownButton_no"
                    }]}
                />
            </div>
            <div className="col-md-2 text-right">
                <div className="d-flex justify-content-end gap-8 ml-8">
                    <Button type={ButtonType.SECONDARY}
                            onClick={this.saveRow}
                            disabled={!isSaveEnabled}
                            text={this.props.translate("costUnitAssignApprovers.save")}
                    />
                    <Button type={ButtonType.SECONDARY}
                            onClick={this.props.cancelEdit}
                            text={this.props.translate("roles.cancel")}
                    />
                </div>
            </div>

        </div>)
    }
}

const mapStateToProps = function(store) {
    return {
        costUnitsBranches: reduxSelectors.getCostUnitBranches(store)
    }
};

export const AssignApproversCopyRow = connect(mapStateToProps, {
    getCostUnitsBranches,
})(CostUnitsApproversNewRow);